import request from '@/utils/request'

// get login user info
export function getInfo() {
  return request({
    url: '/api/user/currentUser',
    method: 'get'
  })
}

export function getNonce(query) {
  return request({
    url: '/api/getNonce',
    method: 'get',
    params: query
  })
}

export function getAccountList(address) {
  return request({
    url: '/api/getAccountList?address=' + address,
    method: 'get'
  })
}

export function handleLogin(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

// 获取合约地址和abi
export function getContract(name) {
  return request({
    url: `/api/contracts/abi?name=${name}`,
    method: 'get'
  })
}
